/* --------------------------------------------------------------------------------------------
 * Copyright (c) 2018-2022 TypeFox GmbH (http://www.typefox.io). All rights reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 * ------------------------------------------------------------------------------------------ */

import { createEditorForLanguage, loadLanguageWebsocket, initializeVSServices } from 'examples-main';
import { buildWorkerDefinition } from 'monaco-editor-workers';

declare global {
    interface Window {
        languageClient: {
            loadLanguageWebsocket: Function,
            initializeVSServices: Function,
            createEditorForLanguage: Function,
            buildWorkerDefinition: Function
        }
    }
}

window.languageClient = {
    loadLanguageWebsocket,
    initializeVSServices,
    createEditorForLanguage,
    buildWorkerDefinition
};
